import React, { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Select from "react-select";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";

//Context
import { useAuth } from "../../../context/auth";

//Services
import { InputCEP } from "../../../services/mask";
import { showMessage } from "../../../services/message";
import { GetCEPViaCEP } from "../../../services/viaCep";

//API
import { api_POST, api_PUT } from "../../../services/api_service";

export default function DadosObra({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();
  const [registro, setRegistro] = useState(null);
  const [modalOpen, set_modalOpen] = useState(false);
  const [localizacaoConfirmada, set_localizacaoConfirmada] = useState(false);

  const [optionsTipoEmpreendimento] = useState([
    { label: "SELECIONE", value: "0" },
    { label: "Público", value: "Público" },
    { label: "Privado", value: "Privado" },
    { label: "Público/Privado", value: "Público/Privado" },
  ]);
  const [optionsTipoConstrucao] = useState([
    { label: "SELECIONE", value: "0" },
    { label: "Leve/Vertical", value: "Leve/Vertical" },
    { label: "Leve/Horizontal", value: "Leve/Horizontal" },
    { label: "Pesada", value: "Pesada" },
  ]);
  const [optionsTipologia] = useState([
    { label: "SELECIONE", value: "0" },
    { label: "Residencial", value: "Residencial" },
    { label: "Comercial", value: "Comercial" },
    { label: "Serviços", value: "Serviços" },
    { label: "Indústria", value: "Indústria" },
    { label: "Misto", value: "Misto" },
    { label: "Outros", value: "Outros" },
    { label: "Saneamento", value: "Saneamento" },
    { label: "Transporte", value: "Transporte" },
    { label: "Energia", value: "Energia" },
  ]);

  const {
    register,
    control,
    handleSubmit,
    errors,
    setValue,
    clearErrors,
    watch,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      empreendimento: "",
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      uf: "",
      latitude: "",
      longitude: "",
      areaConstruir: "",
      areaDemolir: "",
      volumeReceber: "",
      volumeDestinar: "",
      tipoEmpreendimento: optionsTipoEmpreendimento[0] || {
        label: "SELECIONE",
        value: "0",
      },
      tipoConstrucao: optionsTipoConstrucao[0] || {
        label: "SELECIONE",
        value: "0",
      },
      tipologia: optionsTipologia[0] || { label: "SELECIONE", value: "0" },
    },
  });

  const getObraData = () => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    const obraList = isRequerimento
      ? item?.requerimentoGerador?.[0]?.requerimentoGeradorObras
      : item?.protocoloGerador?.[0]?.protocoloGeradorObras;

    if (
      obraList &&
      obraList?.length > 0 &&
      !!obraList[0]?.latitude &&
      !!obraList[0]?.longitude
    ) {
      setCenterMap([obraList[0]?.latitude, obraList[0].longitude]);
      setpositionMarker([obraList[0].latitude, obraList[0].longitude]);
    }

    return obraList?.length ? obraList[0] : null;
  };

  const setAllValues = (obra) => {
    const selectFields = {
      tipoEmpreendimento: [...optionsTipoEmpreendimento],
      tipoConstrucao: [...optionsTipoConstrucao],
      tipologia: [...optionsTipologia],
    };

    const fields = [
      "empreendimento",
      "tipoEmpreendimento",
      "tipoConstrucao",
      "areaConstruir",
      "areaDemolir",
      "volumeReceber",
      "volumeDestinar",
      "tipologia",
      "cep",
      "logradouro",
      "bairro",
      "numero",
      "complemento",
      "cidade",
      "uf",
      "latitude",
      "longitude",
    ];

    fields.forEach((field) => {
      const value = obra[field];

      if (value) {
        if (selectFields[field]) {
          const option = selectFields[field].find((opt) => opt.value === value);
          if (option) {
            setValue(field, option, { shouldValidate: true });
          }
        } else {
          setValue(field, value, { shouldValidate: true });
        }
      }
    });
  };

  const handleCEP = (event) => {
    clearErrors("cep");

    if (event.target.value.replace(/[^0-9]/g, "").trim().length < 8) {
      setValue("cep", "");
      showMessage(
        "Aviso",
        "Cep inválido. só é permitido preencher com números",
        "error",
        null
      );
      return;
    }

    GetCEPViaCEP(event.target.value).then((result) => {
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == "true")
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);

        if (!!result.data.logradouro && result.data.logradouro.length > 0) {
          let chave =
            result.data.logradouro.replaceAll(" ", "+") +
            "," +
            result.data.bairro.replaceAll(" ", "+") +
            result.data.localidade.replaceAll(" ", "+");
          UpdatePositionEndereco(chave);
        }
      }
    });
  };

  const handleNumeroChange = (value) => {
    let data = getValues();
    let chave =
      data.logradouro.replaceAll(" ", "+") +
      "," +
      value +
      "," +
      data.bairro.replaceAll(" ", "+") +
      data.cidade.replaceAll(" ", "+");
    UpdatePositionEndereco(chave);
  };

  async function UpdatePositionEndereco(chave) {
    setLoading(true);
    api_POST(`GeoCoding/GetPositionEndereco`, chave)
    .then((result) => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", "error", null);
      } else {
        try {
          setCenterMap([
            result?.data?.latitude?.replace(",", "."),
            result?.data?.longitude?.replace(",", "."),
          ]);
          setpositionMarker([
            result?.data?.latitude?.replace(",", "."),
            result?.data?.longitude?.replace(",", "."),
          ]);
        } catch {
          showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", "error", null);
        }
      }
    })
    .catch((err) => showMessage("Aviso", err.message, "error", null))
    .finally(() => setLoading(false));
  }

  // Mapa
  const [centerMap, setCenterMap] = useState([0, 0]);
  const [positionMarker, setpositionMarker] = useState([0, 0]);
  const iconMarker = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
    iconRetinaUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
  });
  const markerRef = useRef(null);
  const handleMarkerPosition = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          let position = marker.getLatLng();
          setpositionMarker([position.lat, position.lng]);
        }
      },
    }),
    []
  );
  const ChangeMap = ({ center, zoom }) => {
    const mapInstance = useMap();
    mapInstance.setView(center, zoom);
    return null;
  };
  const handleModalClose = () => {
    set_modalOpen(false);
    set_localizacaoConfirmada(true);
  };

  const getTipologiaOptions = () => {
    if (
      tipoConstrucao?.value === "Leve/Vertical" ||
      tipoConstrucao?.value === "Leve/Horizontal"
    ) {
      return [
        { label: "SELECIONE", value: "0" },
        { label: "Residencial", value: "Residencial" },
        { label: "Comercial", value: "Comercial" },
        { label: "Serviços", value: "Serviços" },
        { label: "Indústria", value: "Indústria" },
        { label: "Misto", value: "Misto" },
        { label: "Outros", value: "Outros" },
      ];
    } else if (tipoConstrucao?.value === "Pesada") {
      return [
        { label: "SELECIONE", value: "0" },
        { label: "Saneamento", value: "Saneamento" },
        { label: "Transporte", value: "Transporte" },
        { label: "Energia", value: "Energia" },
        { label: "Outros", value: "Outros" },
      ];
    }
    return [];
  };

  function handleCriarObjetoTipoRequerimento(data) {
    const obra =
      registro?.requerimentoGerador?.[0]?.requerimentoGeradorObras?.[0];

    return {
      ...obra,
      empreendimento: data.empreendimento,
      cep: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      areaConstruir: data.areaConstruir,
      areaDemolir: data.areaDemolir,
      volumeReceber: data.volumeReceber,
      volumeDestinar: data.volumeDestinar,
      tipoEmpreendimento: data.tipoEmpreendimento?.value,
      tipoConstrucao: data.tipoConstrucao?.value,
      tipologia: data.tipologia?.value,
      latitude: positionMarker[0],
      longitude: positionMarker[1],
    };
  }

  function handleCriarObjetoTipoProtocolo(data) {
    const obra = registro?.protocoloGerador?.[0]?.protocoloGeradorObras?.[0];
    return {
      ...obra,
      empreendimento: data.empreendimento,
      cep: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      latitude: positionMarker[0],
      longitude: positionMarker[1],
      areaConstruir: data.areaConstruir,
      areaDemolir: data.areaDemolir,
      volumeReceber: data.volumeReceber,
      volumeDestinar: data.volumeDestinar,
      tipoEmpreendimento: data.tipoEmpreendimento?.value,
      tipoConstrucao: data.tipoConstrucao?.value,
      tipologia: data.tipologia?.value,
    };
  }

  const onSubmit = async (data) => {
    if (!localizacaoConfirmada) {
      set_modalOpen(true);
      return;
    }

    if (
      !data?.tipoEmpreendimento?.value ||
      data?.tipoEmpreendimento?.value === "0"
    )
      return showMessage(
        "Aviso",
        "Selecione o tipo de empreendimento, por favor!",
        "warning",
        null
      );

    if (!data?.tipoConstrucao?.value || data?.tipoConstrucao?.value === "0")
      return showMessage(
        "Aviso",
        "Selecione o tipo de construção, por favor!",
        "warning",
        null
      );

    if (!data?.tipologia?.value || data?.tipologia?.value === "0")
      return showMessage(
        "Aviso",
        "Selecione o tipologia, por favor!",
        "warning",
        null
      );

    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    if (isRequerimento) {
      setLoading(true);
      try {
        const objRequerimento = handleCriarObjetoTipoRequerimento(data);

        let resposta;

        resposta = await api_PUT(
          "RequerimentoGerador/PutRequerimentoGeradorObra/endereco",
          objRequerimento
        );

        const novaObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorObras = [
            novaObra,
          ];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const objProtocolo = handleCriarObjetoTipoProtocolo(data);

        let resposta;

        resposta = await api_PUT(
          "ProtocoloGerador/PutProtocoloGeradorObra/endereco",
          objProtocolo
        );

        const novaObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorObras = [
            novaObra,
          ];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  // Observar valor de tipoConstrucao
  const tipoConstrucao = watch("tipoConstrucao");

  useEffect(() => {
    if (item) {
      setRegistro(item);
      const obraData = getObraData();
      if (obraData) setAllValues(obraData);
    }
  }, [item]);

  return (
    <Card className={`card-stats`}>
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
            <h2 className="titulo-solicitacao">Dados da Obra</h2>
            <Row>
              <Col md="12" lg={12}>
                <Row>
                  {/* Empreendimento */}
                  <Col md="12" lg="6">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Empreendimento</label>
                      </b>
                      <Input
                        type="text"
                        name="empreendimento"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        autoComplete="off"
                        maxLength="150"
                      />
                      {errors.empreendimento && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="12" lg="6">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>Tipo de Empreendimento</label>
                      </b>
                      <Controller
                        name="tipoEmpreendimento"
                        control={control}
                        rules={{ required: true }}
                        as={
                          <Select
                            options={[
                              { label: "Público", value: "Público" },
                              { label: "Privado", value: "Privado" },
                              {
                                label: "Público/Privado",
                                value: "Público/Privado",
                              },
                            ]}
                            placeholder="Selecione"
                          />
                        }
                      />
                      {errors.tipoEmpreendimento && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Tipo Construção */}
                  <Col md="12" lg="4">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>Tipo de Construção</label>
                      </b>
                      <Controller
                        name="tipoConstrucao"
                        control={control}
                        rules={{ required: true }}
                        as={
                          <Select
                            options={[
                              {
                                label: "Leve/Vertical",
                                value: "Leve/Vertical",
                              },
                              {
                                label: "Leve/Horizontal",
                                value: "Leve/Horizontal",
                              },
                              { label: "Pesada", value: "Pesada" },
                            ]}
                            placeholder="Selecione"
                          />
                        }
                      />

                      {errors.tipoConstrucao && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Área Construir */}
                  <Col md="12" lg="4">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Área a Construir (m²)</label>
                      </b>
                      <Input
                        type="number"
                        name="areaConstruir"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        autoComplete="off"
                      />
                      {errors.areaConstruir && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Área Demolir */}
                  <Col md="12" lg="4">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Área a Demolir (m²)</label>
                      </b>
                      <Input
                        type="number"
                        name="areaDemolir"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        autoComplete="off"
                      />
                      {errors.areaDemolir && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Volume Receber */}
                  <Col md="12" lg="4">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Volume a Receber (m³)</label>
                      </b>
                      <Input
                        type="number"
                        name="volumeReceber"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        maxLength="15"
                        autoComplete="off"
                      />
                      {errors.volumeReceber && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Volume Destinar */}
                  <Col md="12" lg="4">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Volume a Destinar (m³)</label>
                      </b>
                      <Input
                        type="number"
                        name="volumeDestinar"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        maxLength="15"
                        autoComplete="off"
                      />
                      {errors.volumeDestinar && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Tipologia */}
                  <Col md="12" lg="4">
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Tipologia</label>
                      </b>
                      <Controller
                        name="tipologia"
                        control={control}
                        rules={{ required: true }}
                        as={
                          <Select
                            options={getTipologiaOptions()}
                            placeholder="Selecione"
                          />
                        }
                      />
                      {errors.tipologia && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12} lg={12}>
                    <h4
                      style={{
                        borderBottom: "solid 1px #ccc",
                        width: "100%",
                      }}
                    >
                      Endereço da Obra
                    </h4>
                  </Col>
                </Row>
                <Row>
                  {/* CEP */}
                  <Col md="12" lg={2}>
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>CEP</label>
                      </b>
                      <InputCEP
                        name="cep"
                        defaultValue={
                          item
                            ? opcao.tipoCadastro === "Requerimento"
                              ? item?.requerimentoGerador?.[0]
                                  ?.requerimentoGeradorObras?.[0]?.cep || ""
                              : item?.protocoloGerador?.[0]
                                  ?.protocoloGeradorObras?.[0]?.cep || ""
                            : ""
                        }
                        onBlur={handleCEP}
                        inputRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                      />
                      {errors.cep && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Logradouro */}
                  <Col md="12" lg={6}>
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>Logradouro</label>
                      </b>
                      <Input
                        type="text"
                        name="logradouro"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        maxLength="100"
                        autoComplete="off"
                      />
                      {errors.logradouro && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Bairro */}
                  <Col md="12" lg={4}>
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>Bairro</label>
                      </b>
                      <Input
                        type="text"
                        name="bairro"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        maxLength="100"
                        autoComplete="off"
                      />
                      {errors.bairro && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Número */}
                  <Col md="12" lg={2}>
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Número</label>
                      </b>
                      <Input
                        type="number"
                        name="numero"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        onBlur={(e) => handleNumeroChange(e.target.value)}
                        maxLength="10"
                        autoComplete="off"
                      />
                      {errors.numero && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Complemento */}
                  <Col md="12" lg={4}>
                    <FormGroup>
                      <b>
                        <label>Complemento</label>
                      </b>
                      <Input
                        type="text"
                        name="complemento"
                        maxLength="50"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>

                  {/* Cidade */}
                  <Col md="12" lg={3}>
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>{" "}
                        <label>Cidade</label>
                      </b>
                      <Input
                        type="text"
                        name="cidade"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        readonly="readonly"
                        maxLength="100"
                        autoComplete="off"
                      />
                      {errors.cidade && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>

                  {/* UF */}
                  <Col md="12" lg={2}>
                    <FormGroup>
                      <b>
                        <span className="text-danger">* </span>
                        <label>UF</label>
                      </b>
                      <Input
                        type="text"
                        name="uf"
                        readonly="readonly"
                        innerRef={register({
                          required:
                            session != null &&
                            session.tipoAcesso === "AreaRestrita"
                              ? false
                              : true,
                        })}
                        maxLength="2"
                        autoComplete="off"
                      />
                      {errors.uf && (
                        <span className="form-control-label text-danger">
                          * Campo Obrigatório
                        </span>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="1" lg="1">
                    <Button
                      color="info"
                      className="btn-mobile"
                      type="button"
                      onClick={() => set_modalOpen(true)}
                    >
                      <i className="fas fa-map-marked-alt"></i>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="text-left">
                <Button
                  color="secundary"
                  onClick={() => {
                    handleStepAnterior(registro);
                  }}
                  className="btn-mobile"
                  type="submit"
                >
                  <i className="fas fa-chevron-left"></i>
                  Voltar
                </Button>
              </Col>
              <Col lg="6" className="text-right">
                <Button color="success" className="btn-mobile" type="submit">
                  Próxima Etapa <i className="fas fa-chevron-right"></i>
                </Button>
              </Col>
            </Row>

            <Modal
              centered
              isOpen={modalOpen}
              toggle={handleModalClose}
              zIndex="9999999"
            >
              <ModalBody className="md-bd">
                <h6>Confirme o Local no Mapa</h6>
                <Row className="mt-2">
                  <Col lg="12">
                    <div id="map">
                      <MapContainer style={{ zIndex: "0" }}>
                        <ChangeMap center={centerMap} zoom={20}></ChangeMap>
                        <TileLayer
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                          opacity={0.5}
                        />
                        <Marker
                          position={positionMarker}
                          draggable={true}
                          icon={iconMarker}
                          ref={markerRef}
                          eventHandlers={handleMarkerPosition}
                        ></Marker>
                      </MapContainer>
                    </div>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter className="md-ft">
                <Button color="secondary" outline onClick={handleModalClose}>
                  Confirmar
                </Button>
              </ModalFooter>
            </Modal>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
